module.exports = __webpack_public_path__ + "img/appointmentDatePerson.7ccb71da.png";